/**
 * Service to control scrolling on page navigation
 * We can't use riba view's built-in scroll handling because it always scrolls to top on navigation which we don't want on history navigation (back/forward)
 * This service works by watching location changes and detecting if they were caused by popstate events shortly earlier.
 * See #66332
 */
export class ScrollingService {
  public static instance?: ScrollingService

  #lastPopState: { path: string; date: number } | undefined
  #lastCheckedPath: string = location.pathname

  constructor() {
    this.#startLocationWatcher()
  }

  public static getSingleton() {
    if (this.instance) {
      return this.instance
    }

    throw new Error(
      'Singleton of ScrollingService not defined! Use ScrollingService.init() before!',
    )
  }

  public static init() {
    if (ScrollingService.instance) {
      throw new Error(`Singleton of ScrollingService already defined!`)
    }
    this.instance = new ScrollingService()
    return ScrollingService.instance
  }

  #startLocationWatcher() {
    window.addEventListener('popstate', () => {
      this.#lastPopState = {
        path: location.pathname,
        date: Date.now(),
      }
    })

    setInterval(() => this.#check(), 100)
  }

  #check() {
    const newPath = location.pathname
    if (newPath === this.#lastCheckedPath) {
      return
    }

    this.#lastCheckedPath = newPath

    if (
      this.#lastPopState &&
      (this.#lastPopState.path !== newPath ||
        Date.now() - this.#lastPopState.date >= 1000)
    ) {
      // was a normal navigation
      this.#lastPopState = undefined
    }

    if (!this.#lastPopState) {
      // For normal navigations always scroll to top
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    }
  }
}
